import { render } from "./ComparativePillarsEquity.vue?vue&type=template&id=787736ac"
import script from "./ComparativePillarsEquity.vue?vue&type=script&lang=js"
export * from "./ComparativePillarsEquity.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__